module.exports = __webpack_public_path__ + "98b2cb56d82817be727f43b4583525ac.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/garavano.png
// module id = 601
// module chunks = 0